import { CustomComponentName } from '@typings';
import { CUSTOM_COMPONENT_NAME } from '@constants';

import {
  ParamReferenceImage,
  ParamReferenceResourcePreset,
  ParamReferenceSecret,
  ParamReferenceStorage,
  ParamReferenceTags,
} from './ParamReferences';

const CONSISTENT_CUSTOM_DEF_COMPONENTS = {
  PRESET: {
    component: ParamReferenceResourcePreset,
    keys: CUSTOM_COMPONENT_NAME.PRESET,
  },
  SECRET: {
    component: ParamReferenceSecret,
    keys: CUSTOM_COMPONENT_NAME.SECRET,
  },
  STORAGE_PATH: {
    component: ParamReferenceStorage,
    keys: CUSTOM_COMPONENT_NAME.STORAGE_PATH,
  },
  IMAGE: {
    component: ParamReferenceImage,
    keys: CUSTOM_COMPONENT_NAME.IMAGE,
  },
  TAGS: {
    component: ParamReferenceTags,
    keys: CUSTOM_COMPONENT_NAME.TAGS,
  },
};

type Props = {
  schemaKey: string;
  typeName: CustomComponentName[0];
  value: any;
};

export const SchemaParamReference: React.FC<Props> = ({
  schemaKey,
  typeName,
  value,
}) => {
  const customDefComponent = Object.values(
    CONSISTENT_CUSTOM_DEF_COMPONENTS,
  ).find(
    ({ keys: [type, propertyName] }) =>
      type === typeName && propertyName === schemaKey,
  );

  if (customDefComponent) {
    const Component = customDefComponent.component;
    return <Component value={value} />;
  }
  /**
   * Fallback
   */
  return <p>{value}</p>;
};
